import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Load translations using http
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    supportedLngs: ['en', 'bn'], // Supported languages
    fallbackLng: 'bn', // Default to Bengali
    lng: 'bn', // Force Bengali as default for everyone
    debug: false, // Set to true for development debugging

    detection: {
      order: ['localStorage', 'cookie'], // Only check saved preferences
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'fajr_language',
      lookupCookie: 'fajr_language',
      checkWhitelist: true
    },

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      // The JS bundle gets a new hashed name every build, but this file keeps
      // its name and is served without Cache-Control, so browsers kept an old
      // copy for days: a deploy that added words showed raw keys such as
      // "address.area" next to the new field. 'no-cache' makes the browser
      // revalidate on every load — a 304 when nothing changed, the new file
      // when something did.
      requestOptions: { cache: 'no-cache' },
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;